import config from "../constants/settings";

// PROFILE
export const GET_PROFILE = "/api/v1/admin/me";
export const GET_EMPLOYEE_PROFILE = "/api/v1/admin/employees/me/employee";

// USERS
export const GET_USERS_ADMIN = "/api/v1/admin/users";
export const GET_USER_ADMIN = (id) => `/api/v1/admin/users/${id}`;
export const GET_USERS_ADMIN_ROLES_LIST = "/api/v1/admin/users/roles/list";
export const POST_USERS_ADMIN_CREATE = "/api/v1/admin/users";
export const DELETE_USERS_ADMIN_DESTROY = "/api/v1/admin/users";
export const GET_USERS_ADMIN_PERMISSIONS_LIST = "/api/v1/admin/users/permissions/list";
export const GET_USERS_ADMIN_PERMISSIONS_ROLE_LIST = (rol_id) => `/api/v1/admin/users/roles/${rol_id}/permissions/list`;
export const PATCH_USERS_ADMIN_PERMISSIONS = (user_id) => `/api/v1/admin/users/${user_id}/permissions`;
export const PATCH_USERS_ADMIN_ROLES = (user_id) => `/api/v1/admin/users/${user_id}/roles`;
export const PUT_USERS_ADMIN_STATUS = (user_id) => `/api/v1/admin/users/${user_id}/status`;
export const PUT_USER_ADMIN_UPDATE = (user_id) => `/api/v1/admin/users/${user_id}`;
export const GET_ROLES_ADMIN_BY_USER = (user_id) => `/api/v1/admin/users/${user_id}/roles`;
export const GET_PERMISSIONS_ADMIN_BY_USER = (user_id) => `/api/v1/admin/users/${user_id}/permissions`;

// Employees
export const GET_EMPLOYEES_ADMIN = "/api/v1/admin/employees";
export const GET_TEMPLATES_EMPLOYEES_ADMIN = "/api/v1/admin/employees/file/layout";
export const GET_EMPLOYEE_ADMIN = (id) => `/api/v1/admin/employees/${id}`;
export const POST_EMPLOYEES_ADMIN_CREATE = "/api/v1/admin/employees";
export const DELETE_EMPLOYEES_ADMIN_DESTROY = "/api/v1/admin/employees/bulk.json/delete";
export const GET_EMPLOYEES_ADMIN_IMPORT = "/api/v1/admin/employees/import/file";
export const POST_EMPLOYEES_ADMIN_IMPORT = "/api/v1/admin/employees/bulk.file";
export const DEL_EMPLOYEES_ADMIN_IMPORT_DELETE = "/api/v1/admin/employees/bulk.file/delete";
export const PUT_EMPLOYEES_ADMIN_IMPORT_STATUS = "/api/v1/admin/employees/bulk.file/status";
export const PUT_EMPLOYEES_ADMIN_CREATE = (employee_id) => `/api/v1/admin/employees/${employee_id}`

// Employees Address
export const GET_ADDRESSES_ADMIN_EMPLOYEE = (employee_id) => `/api/v1/admin/employees/${employee_id}/addresses`
export const GET_ADDRESS_ADMIN_EMPLOYEE = (employee_id, id) => `/api/v1/admin/employees/${employee_id}/addresses/${id}`
export const POST_EMPLOYEES_ADMIN_CREATE_ADDRESS = (employee_id) => `/api/v1/admin/employees/${employee_id}/addresses/bulk.json`
export const PUT_ADDRESS_ADMIN_EMPLOYEE = (employee_id, id) => `/api/v1/admin/employees/${employee_id}/addresses/${id}`
export const DEL_ADDRESS_ADMIN_EMPLOYEE = (employee_id, id) => `/api/v1/admin/employees/${employee_id}/addresses/${id}`

// Cost-Center
export const GET_COST_CENTERS_ADMIN = "/api/v1/admin/cost-centers";
export const GET_COST_CENTERS_ADMIN_NOT_EMPOLOYEES = "/api/v1/admin/cost-centers/employees";
export const POST_COST_CENTER_ADMIN_CREATE = "/api/v1/admin/cost-centers";
export const PUT_COST_CENTER_ADMIN_UPDATE = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}`;
export const DEL_COST_CENTER_DELETE = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}`;
export const GET_COST_CENTER_EMPLOYEES_ADMIN = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}/employees`;
export const PUT_COST_CENTER_EMPLOYEES_ADMIN = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}/employees`;
export const DEL_COST_CENTER_EMPLOYEES_ADMIN = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}/employees`;
export const GET_COST_CENTER_REPORT_ADMIN = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}/report`;
export const GET_COST_CENTER_ADMIN = (cost_center_id) => `/api/v1/admin/cost-centers/${cost_center_id}`;
export const GET_COST_CENTER_REPORTS_ADMIN = "/api/v1/admin/cost-centers/reports";
export const POST_COST_CENTER_POLICY_EMPLOYEE_ADMIN = (cost_center_id, employee_id) => `/api/v1/admin/cost-centers/${cost_center_id}/policy/${employee_id}`;
export const PUT_COST_CENTER_POLICY_EMPLOYEE_ADMIN = (cost_center_id, employee_id) => `/api/v1/admin/cost-centers/${cost_center_id}/policy/${employee_id}`;
export const GET_COST_CENTER_POLICY_EMPLOYEE_ADMIN = (cost_center_id, employee_id) => `/api/v1/admin/cost-centers/${cost_center_id}/policy/${employee_id}`;
export const GET_SUB_ADMINS_COST_CENTER = "/api/v1/admin/cost-centers-admin";
export const POST_CREATE_SUB_ADMINS_CONST_CENTER = "/api/v1/admin/cost-centers-admin";
export const DEL_SUB_ADMINS_COST_CENTER = "/api/v1/admin/cost-centers-admin";


// Services
export const GET_SERVICES_ADMIN = "/api/v1/taxi/requests";
export const GET_SERVICE_ADMIN = (id) => `/api/v1/taxi/platform/bookings/${id}`;
export const GET_SERVICE_REQUEST_ADMIN = (id) => `/api/v1/taxi/platform/requests/${id}`;
export const POST_SERVICES_ADMIN = "/api/v1/taxi/platform/requests";
export const DEL_SERVICES_ADMIN = "/api/v1/taxi/platform/requests";
export const DEL_SERVICES_RESERV_ADMIN = "/api/v1/taxi/platform/bookings";
export const POST_SERVICES_ASSIGN_ADMIN = "/api/v1/taxi/platform/assign";
export const PATCH_UNASSIGN_SERVICES = "/api/v1/taxi/platform/bookings/unassign";
export const PUT_SERVICES_ADMIN = (request_id) => `/api/v1/taxi/requests/${request_id}/individual`;
export const POST_SERVICES_ARRIVAL_ADMIN = "/api/v1/taxi/requests/arrival";
export const PUT_SERVICES_ARRIVAL_ADMIN = (request_id) => `/api/v1/taxi/requests/${request_id}/arrival`;
export const POST_SERVICES_LEAVING_ADMIN = "/api/v1/taxi/requests/leaving";
export const PUT_SERVICES_LEAVING_ADMIN = (request_id) => `/api/v1/taxi/requests/${request_id}/leaving`;
export const PATCH_STATUS_SERVICES_ADMIN = "/api/v1/taxi/requests/status";
export const PUT_PLATFORM_REQUEST = "/api/v1/taxi/platform/requests";
export const PATCH_UPDATE_REQUEST = "/api/v1/taxi/platform/requests";
export const GET_MAP_CLIP_SERVICES = (request_id) => `/api/v1/taxi/platform/trips/${request_id}/resume?type=url`;
export const PATCH_END_WITHOUT_PASSENGER = (id) => `/api/v1/taxi/platform/bookings/${id}/finished`;
export const GET_EMPLOYEE_REQUESTS = "/api/v1/taxi/employee/requests";
export const GET_EMPLOYEE_BOOKINGS = "/api/v1/taxi/employee/bookings";
export const GET_TRIPS_TIMELINE = "/api/v1/taxi/timeline/time-line/trip";
export const PATCH_UPDATE_SERVICE_NOTE = "/api/v1/taxi/platform/bookings/notes";

// Services (Bookings) Notes
export const POST_CREATE_NOTE = (id) => `/api/v1/taxi/platform/bookings/${id}/notes`;
export const GET_LIST_NOTES =(id) => `/api/v1/taxi/platform/bookings/${id}/notes`;

// Services (Pre Request)
export const POST_PRE_REQUEST = "/api/v1/taxi/platform/coke/pre-requests";
export const GET_PRE_REQUEST = "/api/v1/taxi/platform/coke/pre-requests";

// Sync Coke Trips
export const GET_IMPORT_COKE_ROUTES = "/api/v1/sync/coke/trips";
export const GET_TASK_PROGRESS = (task_id) => `/api/v1/sync/coke/tasks/${task_id}/progress`;

// Routes and Stops
export const GET_ROUTES = (partner_id, cost_center_id) => `/api/v1/taxi/partners/${partner_id}/cost_centers/${cost_center_id}/routes`;
export const GET_ROUTES_STOPS = (partner_id, route_id) => `/api/v1/taxi/partners/${partner_id}/routes/${route_id}/stops`;

// Drivers

export const GET_DRIVERS_AVAILABLE_ADMIN = "/api/v1/taxi/driver/available";

// Orgs

export const GET_ORGS_ADMIN = `/api/v1/admin/orgs/${config.api.idGroup}/partners`;

// Gpx Studio
export const GET_TRIPS_RESUME = (code, type = 'gpx') => { return `/api/v1/taxi/platform/trips/${code}/resume?type=${type}`; };

// Plates
export const GET_PLATES = (status, page, size, plate = '') => {
  let url = `/api/v1/taxi/system/drivers?status=${status}&page=${page}&size=${size}`;
  if (plate) {
    url += `&plate=${plate}`; 
  }

  return url;
};

export const GET_PLATES_ONBOARD = (business_line, page, size, plate = '') => {
  let url = `/api/v1/system/vehicles/business_line?business_line=${business_line}&page=${page}&size=${size}`;
  if (plate) {
    url += `&plate=${plate}`;
  }
  return url;
};

 

// Validation Location

// export const POST_VALIDATION_LOCATIONS = `/api/v1/taxi/platform/requests/validation/locations`;